import { createAction, props } from '@ngrx/store';

export const loadViewedReportIds = createAction(
  '[Viewed Report Ids] Load Viewed Report Ids',
  props<{ username: string }>()
);

export const loadViewedReportIdsComplete = createAction(
  '[Viewed Report Ids] Load Viewed Report Ids Complete',
  props<{ ids: number[] }>()
);
